import { useEffect, useRef } from "react";

export default function PaginationSentinel({
  enabled,
  loading,
  onLoadMore,
  loadingLabel = "Loading...",
  testId,
}) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || !enabled || loading || typeof onLoadMore !== "function") {
      return undefined;
    }
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      return undefined;
    }

    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          onLoadMore();
        }
      },
      { root: null, rootMargin: "600px 0px", threshold: 0.01 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [enabled, loading, onLoadMore]);

  return (
    <div
      ref={sentinelRef}
      className="posts-pagination-sentinel"
      data-testid={testId}
      aria-hidden={!loading}
    >
      {loading ? (
        <span className="posts-pagination-loading" role="status">
          {loadingLabel}
        </span>
      ) : null}
    </div>
  );
}
